<template>
  <el-image-viewer
    v-if="isShow"
    :on-close="close"
    :url-list="imgList"
    style="z-index: 99999"/>
</template>

<script>
  export default {
    components: {
      'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
    },
    props: {
    },
    data() {
      return {
        isShow: false,
        imgList:[]
      };
    },
    methods: {
      show(imageList){
        if(!imageList || imageList.length == 0) {
          return
        }
        this.isShow = true
        this.imgList = imageList
      },
      close(){
        this.isShow = false;
      },
    },
  };
</script>
